import { render, staticRenderFns } from "./BellObject.vue?vue&type=template&id=66a10457&scoped=true"
import script from "./BellObject.vue?vue&type=script&lang=js"
export * from "./BellObject.vue?vue&type=script&lang=js"
import style0 from "./BellObject.vue?vue&type=style&index=0&id=66a10457&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a10457",
  null
  
)

export default component.exports